import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FailedRulesToMessagesMapper } from './RulesToMessagesMapper';

export const useFailedRulesToStateMapper = () => {
  const { t } = useTranslation('campaigns');

  return useMemo(() => new FailedRulesToMessagesMapper(t), [t]);
};
